/**
 * roleRules.js
 * Regras de gestão de cargos por loja. Espelha as funções SQL do banco
 * (can_manage_role / can_assign_role): quem pode alterar e quem pode conceder cada cargo.
 */
import { ROLES_HIERARCHY, isSuperAdmin } from './permissions';

// Gerente é o nível mínimo para gerir cargos de quem está abaixo dele
export const MANAGER_LEVEL = 6;
// Proprietário: acima do Gerente; pode também alterar outro Proprietário (exceto o Mestre)
export const OWNER_LEVEL = 7;
// Nível do Desenvolvedor (admin/master): exclusivo da conta do superadmin, nunca concedido
export const DEV_LEVEL = 8;

// Cargos concedíveis, do menor para o maior (sem legados e sem o cargo de Desenvolvedor)
export const ROLE_OPTIONS = [
  'operador', 'tecnico_estagiario', 'tecnico_pleno', 'tecnico_senior', 'gestor', 'proprietario'
];

// Nomes legados gravados no banco -> nome atual (Técnico Júnior deixou de existir)
const LEGACY_ROLES = { owner: 'proprietario', technician: 'tecnico_pleno', tecnico_junior: 'tecnico_pleno', master: 'admin' };

export const normalizeRole = (role) => {
  const r = String(role || '').toLowerCase();
  return LEGACY_ROLES[r] || r;
};

export const levelOf = (role) => ROLES_HIERARCHY[normalizeRole(role)] || 0;

/**
 * me: { id, level, isSuper }   target: { id, level, isMaster }
 * - não se altera o próprio cargo;
 * - o Mestre só é alterado pelo superadmin;
 * - precisa ser Gerente ou acima e o alvo precisa estar abaixo do seu nível
 *   (Proprietário pode alterar outro Proprietário, exceto o Mestre).
 */
export function canManageRole(me, target) {
  if (!me || !target || me.id === target.id) return false;
  if (me.isSuper) return true;
  if (target.isMaster) return false;
  if (me.level < MANAGER_LEVEL) return false;
  if (target.level < me.level) return true;
  return target.level === OWNER_LEVEL && me.level === OWNER_LEVEL;
}

/** Pode conceder este cargo: abaixo do seu nível (Proprietário concede Proprietário). Desenvolvedor nunca. */
export function canAssignRole(me, role) {
  if (!me) return false;
  const lvl = levelOf(role);
  if (lvl >= DEV_LEVEL) return false;
  if (me.isSuper) return true;
  if (me.level < MANAGER_LEVEL) return false;
  return lvl < me.level || (lvl === OWNER_LEVEL && me.level >= OWNER_LEVEL);
}

/** Nível efetivo do usuário logado numa loja (superadmin é sempre o maior). */
export function myLevelFor(user, lojaRole) {
  return { id: user?.id, isSuper: isSuperAdmin(user), level: isSuperAdmin(user) ? DEV_LEVEL : levelOf(lojaRole) };
}
